var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModalFormUploadCheck(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mingcute:check-fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6924 4.32156C15.8894 4.52728 16 4.80626 16 5.09716C16 5.38805 15.8894 5.66703 15.6924 5.87275L7.81802 14.0953C7.71396 14.204 7.59041 14.2902 7.45444 14.349C7.31846 14.4079 7.17272 14.4381 7.02554 14.4381C6.87836 14.4381 6.73262 14.4079 6.59664 14.349C6.46067 14.2902 6.33712 14.204 6.23306 14.0953L2.32073 10.0107C2.22039 9.90953 2.14035 9.78848 2.08529 9.65464C2.03023 9.5208 2.00125 9.37685 2.00004 9.23119C1.99883 9.08552 2.02541 8.94107 2.07823 8.80625C2.13106 8.67143 2.20906 8.54894 2.30771 8.44594C2.40635 8.34294 2.52364 8.26148 2.65276 8.20632C2.78187 8.15116 2.92021 8.1234 3.0597 8.12467C3.1992 8.12594 3.33705 8.1562 3.46522 8.21369C3.5934 8.27119 3.70932 8.35476 3.80624 8.45954L7.02519 11.8208L14.2062 4.32156C14.3038 4.21962 14.4196 4.13875 14.5471 4.08357C14.6746 4.0284 14.8113 4 14.9493 4C15.0873 4 15.224 4.0284 15.3515 4.08357C15.479 4.13875 15.5948 4.21962 15.6924 4.32156Z",
    fill: "#177BF5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalFormUploadCheck);
export default __webpack_public_path__ + "static/media/modal_form_upload_check.43705a7f7e61d2c63b4a974c81857db5.svg";
export { ForwardRef as ReactComponent };